import type { ReportPeriod } from "../../../api/src/reports/reports.service";

/**
 * The first and the last day of the calendar month, quarter or year before
 * `now`, each at local midnight (R35 to R37 of
 * doc-create-report-page-01a18881d97ad3e4).
 *
 * Each date is built from year, month and day, so it carries no time of `now`
 * (APP-2175) and no day of `now` that could roll a month over (APP-2174). The
 * `Date` constructor carries a month below 0 into the year before, and day 0
 * is the last day of the month before.
 */
export function previousPeriodDates(
  period: ReportPeriod,
  now: Date,
): { startDate: Date; endDate: Date } {
  const year = now.getFullYear();
  const month = now.getMonth();

  switch (period) {
    case "M":
      return {
        startDate: new Date(year, month - 1, 1),
        endDate: new Date(year, month, 0),
      };
    case "Q": {
      const quarterStart = month - (month % 3);
      return {
        startDate: new Date(year, quarterStart - 3, 1),
        endDate: new Date(year, quarterStart, 0),
      };
    }
    case "Y":
      return {
        startDate: new Date(year - 1, 0, 1),
        endDate: new Date(year - 1, 11, 31),
      };
  }
}
